<template>
  <modal-form-helper :data="{...mdldata, title:'Add Company - European Companies Only'}" :form="post">
	<template #body>
		<!-- <div class="d-flex align-items-center position-relative me-3">
      <span class="svg-icon svg-icon-2 position-absolute ms-4">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1"
                transform="rotate(45 17.0365 15.1223)" fill="currentColor"/>
          <path
              d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
              fill="currentColor"/>
        </svg>
      </span>
      <input type="text" data-kt-inbox-listing-filter="search"
             v-model="search.name" @input="searchDebounced"
             class="form-control form-control-sm form-control-solid mw-100 min-w-150px min-w-md-200px ps-12"
             placeholder="Search Company"/>
             
    </div> -->
    <div class="d-flex align-items-center">
      <input v-model="search.name" @input="searchDebounced" type="text" class="form-control form-control-sm form-control-solid" style="border-top-left-radius: 100px !important; border-bottom-left-radius: 100px !important; width:60%;" placeholder="Enter company name">
        <select v-model="search.country" @change="searchDebounced" class="form-control form-control-sm form-control-solid" style="width:40%;border-top-right-radius: 100px !important; border-bottom-right-radius: 100px !important;">
          <option value="" disabled selected>Select Country</option>
          <option v-for="country in eu_countries" :key="country.code" :value="country.code">{{country.name}}</option>
        </select>
        
        <!-- <button type="button" @click="searchDebounced" class="d-flex btn btn-primary"
        style="border-top-right-radius: 100px !important; border-bottom-right-radius: 100px !important;">
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path style="fill:none !important" d="M10.75 10.25L15.25 14.75M7 11.75C4.10051 11.75 1.75 9.3995 1.75 6.5C1.75 3.60051 4.10051 1.25 7 1.25C9.8995 1.25 12.25 3.60051 12.25 6.5C12.25 9.3995 9.8995 11.75 7 11.75Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        <span class="fw-normal ms-1">Search</span>
      </button> -->
    </div>
	  <div class="my-4 scroll-list">
	    <ul class="list-group buyer-list">
        <li style="cursor: pointer;" @click="select(item)" v-for="(item, index) in $_.get(records,'companies')"
                class="list-group-item d-flex justify-content-between align-items-center"
                :class="{'selected': isSelected($_.get(item.basicDetails,'orgNo'), $_.get(item.basicDetails,'companyName'))}">
                {{ $_.get(item.basicDetails,'companyName') }} | {{ $_.get(item.basicDetails,'countryCode') }} | {{ $_.get(item.enhancedDetails,'url') }}
                <input type="radio" name="company" :checked="isSelected($_.get(item.basicDetails,'orgNo'), $_.get(item.basicDetails,'companyName'))">
              </li>

	    </ul>
	  </div>
	</template>
	<template #footer>
	  <button type="button" @click="sendToCreateForm" :disabled="selectedData.number.length === 0" class="btn btn-primary me-3">Add
	  </button>
	  <button
	        @click="close"
	        type="button"
	        class="btn btn-light ml-1"
		>
	  Close
	</button>
	</template>
	</modal-form-helper>
</template>
<style type="text/css" scoped>
	.vm--modal{
		top: 65px !important;
	}
</style>
<script>
import cm from "@mxn/create"
export default {
  mixins: [cm],
  props: {
    records:{
    	default: undefined,
      	required: true,
    },
    searchName:'',
    country_code:'',
  },
  data() {
    return {
			selectedData:{
		      name:'',
		      number:'',
		      address: {
		          street_line_one: '',
		          street_line_two: '',
		          city: '',
		          state: '',
		          postcode: '',
		       },
			},
    	post: new Form({}),
    	search:{
      	name:this.searchName,
        country:''
      },
      eu_countries:[
        { code: "SE", name: "Sweden" },
        { code: "FI", name: "Finland" },
        { code: "DK", name: "Denmark" },
        { code: "DE", name: "Germany" },
        { code: "AT", name: "Austria" },
        { code: "IE", name: "Ireland" },
        { code: "CH", name: "Switzerland" },
        { code: "FR", name: "France" },
        { code: "BE", name: "Belgium" },
        { code: "NL", name: "Netherlands" },
        { code: "ES", name: "Spain" },
        { code: "IT", name: "Italy" },
        { code: "PT", name: "Portugal" },
        { code: "EE", name: "Estonia" },
        { code: "LV", name: "Latvia" },
        { code: "GB", name: "United Kingdom" },
      ],
    };
  },
  created() {
    this.searchDebounced = _.debounce(() => this.fetchUKCompanySearch(), 2 * 1000)
  },
  mounted(){
  	this.eu_countries.sort((a, b) => a.name.localeCompare(b.name));

    this.search.country = eu_countries.some(c => c.code === this.country_code) ? this.country_code : ''

  },
  methods: {
    
    close(){
        this.$emit('close')
    },


    isSelected: function (number, title) {
      if(this.selectedData.number == number && this.selectedData.name ==title){
      	return true
      }
    },
    select: function (item) {
      // this.selectedData.name = item.title
      // this.selectedData.number = item.company_number
      // this.selectedData.address.street_line_one = item.address.address_line_1
      // this.selectedData.address.street_line_two = item.address.address_line_2
      // this.selectedData.address.city = item.address.locality
      // this.selectedData.address.state = item.address.locality
      // this.selectedData.address.postcode = item.address.postal_code

      this.selectedData.name = item.basicDetails.companyName
      this.selectedData.number = item.basicDetails.orgNo
      this.selectedData.address.street_line_one = item.basicDetails?.address?.street
      this.selectedData.address.street_line_two = ''
      this.selectedData.address.city = item.basicDetails?.address?.city
      this.selectedData.address.state = item.basicDetails?.address?.muncipality
      this.selectedData.address.postcode = item.basicDetails?.address?.zipcode
    },
    sendToCreateForm(){
    	this.$root.$emit('company_number', this.selectedData)
    	this.close()
    },

    fetchUKCompanySearch(){
      let name = this.search.name
      let country = this.search.country
      this.startCompLoading();
        axios.get(this.genUrl('companies', null, 'uk_company_finder'), {
          params: {name,country}
        }).then(({data}) => {
              console.log(data)
            this.records = data?.data
        })
        .catch(err => console.error(err))
        .finally(() => this.endCompLoading()); 
    },
    
  },
};
</script>